import { CampaignType } from '../../../../constants/marketingCampaign'
import { BuildFormValuesContext } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { ProductDiscountRuleState } from './types'

export function buildProductDiscountFormValues(
	ctx: BuildFormValuesContext<ProductDiscountRuleState>,
): Record<string, unknown> {
	const { rule, confirmation, selectedShopIds, campaignMeta, marketingCampaignKey } = ctx
	const base: Record<string, unknown> = {
		startDate: confirmation.startDate,
		startTime: confirmation.startTime,
		discount: rule.discount,
		threshold: null,
		type: CampaignType.PRODUCT_DISCOUNT,
		shopIds: selectedShopIds,
		valueType: campaignMeta.valueType,
		products: rule.products,
		hasLimit: confirmation.hasLimit,
		limit: confirmation.hasLimit ? confirmation.limit : null,
		marketingCampaignKey,
		orderTypes: confirmation.orderTypes,
		isPermanent: confirmation.isPermanent,
	}

	if (!confirmation.isPermanent) {
		base.endDate = confirmation.endDate
		base.endTime = confirmation.endTime
	}

	return base
}
